import { withTranslation } from "react-i18next";
import SmsHistories from './SmsHistories';

export default withTranslation()(SmsHistories);